export const SUBMIT_CHANGE_KEYS = ["graphEnabled"];
